import { Phone } from "lucide-react";
import { motion } from "framer-motion";

const FloatingCallCTA = () => {
  return (
    <motion.a
      href="tel:+17722022664"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, duration: 0.4, ease: "easeOut" }}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-primary text-primary-foreground px-5 py-3 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 group"
      aria-label="Call Now — N. Santiago Media at 772-202-2664"
    >
      <Phone className="w-5 h-5 group-hover:animate-pulse" />
      <span className="hidden sm:inline font-semibold text-sm">Call Now</span>
    </motion.a>
  );
};

export default FloatingCallCTA;
